module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"segmentationByKeywords":"Segmentation by keywords"},"fr":{"segmentationByKeywords":"Segmentation par mots clés"},"de":{"segmentationByKeywords":"Segmentierung nach Schlüsselwörtern"}}')
  delete Component.options._Ctor
}
